<template>
  <div id="laboratory-page">
    <v-row noGutters>
      <v-col>
        <Breadcrumbs :items="breadcrumbs" />
      </v-col>
    </v-row>
    <v-row noGutters>
      <BaseSidebar
        :items="sidebarItems"
        :title="$t('laboratory.pageName')"
      />
      <v-col>
        <router-view
          @changePage="pageToDisplay = $event"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/shared/navigation/Breadcrumbs';
import BaseSidebar from '@/components/shared/navigation/BaseSidebar';
import { mapGetters, mapActions } from 'vuex';
import roles from '@/utilities/enums/rolesTypes';

export default {
    components: {
        Breadcrumbs,
        BaseSidebar,
    },
    data() {
        return {
            pageToDisplay: 'laboratory',
        };
    },
    computed: {
        ...mapGetters([
            'breadcrumbs',
            'woTemplate',
            'hasRole',
            'labWorkOrder',
        ]),
        isRep() {
            return this.hasRole(roles.SALESREP);
        },
        isSalesManager() {
            return this.hasRole(roles.SALESMANAGER);
        },
        isOperateur() {
            return this.hasRole(roles.OPERATOR);
        },
        isTechnician() {
            return this.hasRole(roles.SERVICETECH);
        },
        sidebarItems() {
            return [
                {
                    title: 'laboratory.analysisRequests',
                    path: { name: 'analysisRequests' },
                    icon: 'Analysis.svg',
                },
                {
                    title: 'laboratory.workOrders',
                    path: (this.isOperateur || this.isTechnician) ? null : { name: 'labWorkOrders' },
                    icon: 'WorkOrder.svg',
                },
                {
                    title: 'laboratory.samplesRegister',
                    path: (this.isRep || this.isSalesManager || this.isOperateur || this.isTechnician) ? null : { name: 'samplesRegister' },
                    icon: 'SamplesRegister.svg',
                },
                {
                    title: 'laboratory.reports',
                    path: this.isOperateur ? null : { name: 'labReports' },
                    icon: 'Reports.svg',
                },
                {
                    title: 'laboratory.dataTransfer',
                    path: (this.isRep || this.isOperateur || this.isTechnician) ? null : { name: 'dataTransfer' },
                    icon: 'Move_up_black.svg',
                },
                {
                    title: 'laboratory.xmlReport',
                    path: (this.isRep || this.isOperateur || this.isTechnician) ? null : { name: 'xmlReport' },
                    icon: 'Insert_drive_file_black.svg',
                },
            ];
        },
    },
    watch: {
        $route() {
            this.buildFromRoute();
        },
    },
    created() {
        this.buildFromRoute();
    },
    methods: {
        ...mapActions({
            emptyBreadcrumbs: 'emptyBreadcrumbs',
            pushBreadcrumb: 'pushBreadcrumb',
        }),
        buildFromRoute() {
            this.emptyBreadcrumbs();

            const currentPath = this.$route.matched[this.$route.matched.length - 1].path.split('/');
            currentPath.shift();
            currentPath.forEach(route => {
                switch (route) {
                    case ':woTemplateId':
                        this.pushBreadcrumb({
                            name: 'siteEditTemplate',
                            text: `${this.woTemplate.title}`,
                            noTranslate: true,
                        });
                        break;
                    case ':labWorkOrderId':
                        this.pushBreadcrumb({
                            name: 'labAnalysisRequests',
                            text: `${this.labWorkOrder.woNumber}`,
                            noTranslate: true,
                        });
                        break;
                    case 'extractToCsv':
                        this.pushBreadcrumb({
                            name: 'extractToCsv',
                            text: 'permissions.workOrders.extractToCsv',
                        });
                        break;

                    default:
                        this.pushBreadcrumb({
                            name: route,
                            text: `${this.pageToDisplay}.${route}`,
                        });
                        break;
                }
            });
        },
    },

};
</script>
